

export const content = state => {
	return state.content
}

export const categories = state => {
	return state.categories
}

export const products = state => {
	return state.products
}

export const onCategoryView = state => {
	return state.onCategoryView
}

export const getLastCategoryView = state => {
	return state.lastCategoryView
}

export const onProductView = state => {
	return state.onProductView
}

export const isInstalled = state => {
	return state.isBootstraped
}

export const isBootstraped = state => {
	return state.isBootstraped
}

export const isLoading = state => {
	return state.isLoading
}


// WEBPACK FOOTER //
// ./src/store/getters.js